<form [formGroup]='propertyTypeFrom'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<ng-container *ngIf='!this.formService.domainData?.hidePropertyTypeQuestion'>

		<div class='step-title' i18n>What is your current <span class='color-blue'>property type</span>?</div>

		<div class='form-control property-type-control'>
			<mat-radio-group (change)='onRadioChange($event)' formControlName='propertyType' aria-label='Select an option' class='custom-radio-group'>
				<mat-radio-button value='1' [tabIndex]='formService.verifyTabIndex( formGroupName )'>
					<div class='option'>
						<mat-icon inline="true" svgIcon='images:property-type-house' class='option-icon'></mat-icon>
						<div class='option-name' i18n='@@house'>House</div>
					</div>
				</mat-radio-button>
				<mat-radio-button value='2' [tabIndex]='formService.verifyTabIndex( formGroupName )'>
					<div class='option'>
						<mat-icon inline="true" svgIcon='images:property-type-apartment' class='option-icon'></mat-icon>
						<div class='option-name' i18n='@@apartment'>Apartment / flat</div>
					</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>

	</ng-container>


	<!-- This question is only build for german forms -->
	<ng-container *ngIf='m2Enabled'>

		<div class='step-title step-title-margin-top'>Wie groß ist Ihre Immobilie?</div>

		<div class='form-control form-control-m-full'>
			<mat-form-field class='centered-field'>
				<mat-label>Wählen Sie die Wohnfläche Ihrer Immobilie</mat-label>
				<mat-select [tabIndex]='formService.verifyTabIndex( formGroupName )' formControlName='m2'>
					<mat-option *ngFor='let m2Size of m2Sizes' [value]='m2Size.value'>
						{{m2Size.label}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

	</ng-container>

	<ng-container *ngIf='formService.mainForm.controls["_propertyRoomsEnabled"].value && propertyTypeFrom.controls["propertyType"].value'>

		<div class='step-title step-title-margin-top' i18n>What <span class='color-blue'>size</span> is your current property?</div>

		<div class='form-control form-control-m-full'>
			<mat-form-field class='centered-field'>
				<mat-label i18n>Please select an option</mat-label>
				<mat-select [tabIndex]='formService.verifyTabIndex( formGroupName )' formControlName='propertyRooms'>
					<mat-option *ngFor='let propertyRoom of getPropertyRooms()' [value]='propertyRoom.value'>
						{{propertyRoom.label}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

	</ng-container>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>
</form>

